/* eslint-disable require-jsdoc */
import {getGtmProductItemsData} from './getGtmProductItemsData';
import {getCart} from '../../../components/cart-section/js/utils';

export const gtmChangeCart = async (itemsId, quantityValue, listName, isAddToCart = true) => {
    const analyticsData = JSON.parse(localStorage.getItem('analytics'));
    const cartData = JSON.parse(localStorage.getItem('cart_analytics'));
    const taxRate = analyticsData?.tax_rate;
    const quantity = Math.abs(quantityValue);
    let cartItems;

    try {
        const currentCart = await getCart();

        if (isAddToCart) {
            const changedItems = getChangedItems(currentCart.items, itemsId);
            cartItems = getGtmProductItemsData(changedItems, quantity, taxRate);
        } else {
            const changedItems = getChangedItems(cartData.items, itemsId);
            cartItems = changedItems.map((item) => {
                return {...item, quantity: quantity};
            });
        }

/* EX-1229 removed cart_analytics additions to localStorage
        // localStorage.setItem('cart_analytics', JSON.stringify({
            ...currentCart,
            items: currentCart.items.flatMap(
                (item, index) => getGtmProductItemsData([item], item.quantity, taxRate, index),
            ),
        }));
 */
    } catch (e) {
        console.error('Failed to fetch a cart');
        throw e;
    }

    const valueWithVat = cartItems.reduce((acc, item) => acc + (item.priceWithTax * quantity), 0);
    const valueWithoutVat = cartItems.reduce((acc, item) => acc + (item.priceWithoutVat * quantity), 0);

/* EX-1229 - removed dataLayer pushes from our side
    window.dataLayer.push({
        'event': isAddToCart ? 'ec.add_to_cart' : 'ec.remove_from_cart',
        'send_to': analyticsData?.gtm_id,
        'ecommerce': {
            'listName': listName,
            'currencyCode': window.Shopify.currency.active,
            valueWithoutVat,
            valueWithVat,
            'products': cartItems,
        },
        '_clear': true,
    });
    
 */
};

const getChangedItems = (items, itemsId) => {
    const changedItemsId = itemsId.map((id) => Number(id));

    return items.filter((item) => changedItemsId.includes(item.id));
};
